import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawChevronRightIcon.svg.jsx";

const ChevronRightIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default ChevronRightIcon;
